// extracted by mini-css-extract-plugin
export default {"scopeTabs":"M5Thj1PPCw","scopeTabs_scrollable":"xkdObv2rdf"};